<div class="p-fluid p-formgrid p-grid">
  <div class="p-col-12 p-sm-12  p-md-12 p-lg-3">
    <p-card header="Filtros" (keyup)="ds.onEnterPesquisar($event)">
      <div class="p-grid" *ngIf="permissaoIndisponibilidade">
        <m-restricao-number label="Id" [restricao]="ds.restricoes.atributo('id')"></m-restricao-number>
      </div>
      <div class="p-grid">
        <m-restricao-temporal label="Data início" [restricao]="ds.restricoes.atributo('dataInicio')"></m-restricao-temporal>
      </div>
      <div class="p-grid">
        <m-restricao-temporal label="Data Fim" [restricao]="ds.restricoes.atributo('dataFim')"></m-restricao-temporal>
      </div>
      <div class="p-grid">
        <m-restricao-string label="Descrição"  [restricao]="ds.restricoes.atributo('descricao')"></m-restricao-string>
      </div>
      <div class="p-grid">
        <m-restricao-entidade label="Tipo"
                              [restricao]="ds.restricoes.atributo('tipo')"
                              [itens]="indisponibilidadeTipoItens"
                              itemId="value"
                              itemLabel="label">
        </m-restricao-entidade>
      </div>
      <div class="p-grid">
        <m-restricao-entidade label="Afetou Latência?"
                              [restricao]="ds.restricoes.atributo('suspendePrazos')"
                              [itens]="simNaoItens"
                              itemId="value"
                              itemLabel="label">
        </m-restricao-entidade>
      </div>
      <p-footer>
        <div class="p-fluid p-grid">
          <div class="p-field p-col">
            <button pButton label="Pesquisar" (click)="ds.pesquisar()"></button>
          </div>
          <div class="p-field p-col">
            <button pButton class="p-button-secondary" label="Limpar" (click)="ds.limpar()"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>
  <div class="p-col-12 p-sm-12  p-md-12 p-lg-9">
    <p-card header="Lista de Indisponibilidade">
     <p-table
        [value]="ds.entidades"
        [totalRecords]="ds.total"
        (onLazyLoad)="ds.carregar($event)"
        [lazy]="true"
        [(rows)]="ds.registros"
        [paginator]="true"
        responsive="true"
        sortMode="multiple"
        styleClass="p-datatable-striped"
        responsiveLayout="scroll"
        [multiSortMeta]="[{ field: 'dataInicio', order: -1 }]"
        emptyMessage="Nenhum registro encontrado"
        dataKey="id"
        [expandedRowKeys]="expandedRows">
       <ng-template pTemplate="caption">
         <div class="p-grid">
           <div class="p-col-3 p-offset-9">
             <button
               pButton
               [label]="allRowsExpanded ? 'Minimizar' : 'Expandir'"
               [icon]="allRowsExpanded ? 'pi pi-minus' : 'pi pi-plus'"
               (click)="toggleExpandAll()"
               [ngClass]="allRowsExpanded ? 'p-button-info' : ''">
             </button>
           </div>
         </div>
       </ng-template>
       <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"></th>
            <th pSortableColumn="id" class="p-text-center"  style="width: 8rem;" *ngIf="permissaoIndisponibilidade"> Id <p-sortIcon field="id"></p-sortIcon></th>
            <th pSortableColumn="dataInicio">Data início<p-sortIcon field="dataInicio"></p-sortIcon></th>
            <th pSortableColumn="dataFim">Data fim<p-sortIcon field="dataFim"></p-sortIcon></th>
            <th pSortableColumn="suspendePrazos">Afetou Latência<p-sortIcon field="suspendePrazos"></p-sortIcon></th>
            <th pSortableColumn="tipo">Tipo <p-sortIcon field="tipo"></p-sortIcon></th>
            <th class="p-text-center" style="width: 8rem;" *ngIf="permissaoIndisponibilidade"> Ação </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-entidade let-expanded="expanded" style="display: table-column">
          <tr>
            <td>
              <button type="button" pButton pRipple [pRowToggler]="entidade" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
            </td>
            <td class="p-text-center" *ngIf="permissaoIndisponibilidade">{{entidade.id}}</td>
            <td class="p-text-center">{{entidade.dataInicio | date:'dd/MM/yyyy HH:mm:ss'}}</td>
            <td class="p-text-center">{{entidade.dataFim |  date:'dd/MM/yyyy HH:mm:ss'}}</td>
            <td class="p-text-center">
             <span class="badge" [ngClass]="entidade.suspendePrazos ? 'badge-success' : 'badge-danger'">
              {{entidade.suspendePrazos | dominio: 'getSimNaoItens'}}
             </span>
            <td class="p-text-center">{{entidade.tipo | dominio: 'getTipoIndisponibilidade'}}</td>
            <td class="p-text-center" *ngIf="permissaoIndisponibilidade">
              <a
                pButton [routerLink]="['/indisponibilidade/edicao/',
                entidade.id]"
                icon="pi pi-pencil"
                title="Editar"
                class="p-button-sm p-m-r-2" pTooltip="Editar">
              </a>
              <button
                pButton  (click)="iniciarExclusao(entidade)"
                class="p-button-danger p-button-sm"
                icon="pi pi-trash"
                pTooltip="Excluir">
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-entidade>
          <tr>
            <td colspan="8">
              <div class="p-field">
                <label class="p-text-bold p-border">Descrição</label>
                <hr>
                <p-editor
                  [(ngModel)]="entidade.descricao"
                  readonly = true
                  [style]="{border: 0 }"
                  [styleClass]="'custom-editor'">
                </p-editor>
             </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-6"  *ngIf="permissaoIndisponibilidade">
              <a pButton routerLink="/indisponibilidade/novo" class="p-primary" label="Novo"></a>
            </div>
            <div class="p-field p-col-6 p-text-right">
              Quantidade de registros: <span class="p-text-bold">{{ds.total}}</span>
            </div>
          </div>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>
